export enum AUTH_STATE {
  LOADING = 'loading',
  RECONNECTING = 'reconnecting',
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
}
